$(function () {
  var pcflag, spflag, padflag;
  if (window.innerWidth > 1023) {
    pcflag = 1;
    spflag = 0;
    padflag = 0;
  } else if (window.innerWidth > 599 && window.innerWidth < 1024) {
    pcflag = 0;
    spflag = 0;
    padflag = 1;
  } else {
    pcflag = 0;
    spflag = 1;
    padflag = 0;
  }
  $(window).on("resize", function () {
    if (window.innerWidth < 600) {
      if (pcflag || padflag) {
        setTimeout(function () {
          window.location.reload();
        }, 100);
        pcflag = 0;
        spflag = 1;
        padflag = 0;
      }
    } else if (window.innerWidth > 599 && window.innerWidth < 1024) {
      if (pcflag || spflag) {
        setTimeout(function () {
          window.location.reload();
        }, 100);
        pcflag = 0;
        spflag = 0;
        padflag = 1;
      }
    } else {
      if (spflag || padflag) {
        setTimeout(function () {
          window.location.reload();
        }, 100);
        pcflag = 1;
        spflag = 0;
        padflag = 1;
      }
    }
  });

  // $('.happyBox .close').click(function(){
  // 	$(this).parents('.happyBox').hide();
  // });

  if ($(".mainImg .listUl").length) {
    $(".mainImg .listUl").slick({
      centerMode: false,
      slidesToShow: 1,
      centerPadding: 0,
      variableWidth: false,
      slidesToScroll: 1,
      dots: false,
      fade: true,
      pauseOnHover: false,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 3500,
    });
  }

  if ($(".mySwiper").length) {
    var length01 = $(".mySwiper .slideList > li").length;
    new Swiper(".mySwiper", {
      autoplay: false,
      speed: 500,
      slidesPerView: 1.35,
      spaceBetween: "15.9%",
      freeMode: {
        enabled: true,
        momentumBounce: false,
      },
      resistance: true,
      resistanceRatio: 0,
      navigation: {
        nextEl: ".swiper-next.next01",
        prevEl: ".swiper-prev.prev01",
      },
      loop: false,
      breakpoints: {
        600: {
          //>=600
          spaceBetween: "7.2%",
          freeMode: false,
          loop: length01 < 4 ? false : true,
          slidesPerView: 3,
          allowTouchMove: false,
        },
        1024: {
          //>=1024
          spaceBetween: "5.2%",
          freeMode: false,
          loop: length01 < 5 ? false : true,
          slidesPerView: 4,
        },
      },
    });
  }

  if ($(".mySwiper04").length) {
    var length04 = $(".mySwiper04 .slideList > li").length;
    new Swiper(".mySwiper04", {
      autoplay: false,
      speed: 500,
      slidesPerView: 1.35,
      spaceBetween: "15.9%",
      freeMode: {
        enabled: false,
        momentumBounce: false,
      },
      resistance: true,
      resistanceRatio: 0,
      navigation: {
        nextEl: ".swiper-next.next04",
        prevEl: ".swiper-prev.prev04",
      },
      loop: false,
      breakpoints: {
        600: {
          //>=600
          spaceBetween: "7.2%",
          freeMode: false,
          loop: length04 < 4 ? false : true,
          slidesPerView: 3,
          allowTouchMove: false,
        },
        1024: {
          //>=1024
          spaceBetween: "5.2%",
          freeMode: false,
          loop: length04 < 5 ? false : true,
          slidesPerView: 4,
        },
      },
    });
  }

  if ($(".mySwiper02").length) {
    var length02 = $(".mySwiper02 .slideList > li").length;
    new Swiper(".mySwiper02", {
      autoplay: false,
      speed: 500,
      slidesPerView: 1.35,
      spaceBetween: "15.9%",
      freeMode: {
        enabled: true,
        momentumBounce: false,
      },
      resistance: true,
      resistanceRatio: 0,
      navigation: {
        nextEl: ".swiper-next.next02",
        prevEl: ".swiper-prev.prev02",
      },
      loop: false,
      breakpoints: {
        600: {
          spaceBetween: "10.5%",
          freeMode: false,
          loop: length02 < 3 ? false : true,
          slidesPerView: 2,
          allowTouchMove: false,
        },
        1024: {
          spaceBetween: "7.2%",
          freeMode: false,
          loop: length02 < 4 ? false : true,
          slidesPerView: 3,
        },
      },
    });
  }

  if ($(".mySwiper03").length) {
    var length03 = $(".mySwiper03 .slideList > li").length;
    new Swiper(".mySwiper03", {
      autoplay: false,
      speed: 500,
      slidesPerView: 1.95,
      spaceBetween: "11.5%",
      freeMode: {
        enabled: true,
        momentumBounce: false,
      },
      resistance: true,
      resistanceRatio: 0,
      navigation: {
        nextEl: ".swiper-next.next03",
        prevEl: ".swiper-prev.prev03",
      },
      loop: false,
      breakpoints: {
        600: {
          spaceBetween: "7%",
          freeMode: false,
          loop: length03 < 5 ? false : true,
          slidesPerView: 4,
          allowTouchMove: false,
        },
        1024: {
          //>=1024
          spaceBetween: "5.5%",
          freeMode: false,
          loop: length03 < 6 ? false : true,
          slidesPerView: 5,
        },
      },
    });
  }

  if ($(".swiper-area").length) {
    $(window)
      .on("resize", function () {
        $(".swiper-area").each(function () {
          var phoH =
            $(this)
              .find(".slideList > li")
              .eq(0)
              .find(".slideUl")
              .innerHeight() / 2;
          $(this).find(".swiper-next").css("top", phoH);
          $(this).find(".swiper-prev").css("top", phoH);
        });
      })
      .trigger("resize");
  }

  if (window.innerWidth < 600) {
    if ($("#shopify-section-announcement-bar").length) {
      var faqH = 132;
    } else {
      faqH = 76;
    }
    $(".headline04").click(function () {
      var that = $(this);
      $(this).toggleClass("on");
      $(this).next(".innerBox").toggle();
      $(this).parents(".comTextBox").siblings().find(".innerBox").hide();
      $(this)
        .parents(".comTextBox")
        .siblings()
        .find(".headline04")
        .removeClass("on");
      $("html,body").animate({ scrollTop: that.offset().top - faqH }, 300);
      return false;
    });

    $(".storyBox .headline06").click(function () {
      var that = $(this);
      $(this).toggleClass("on");
      $(this).next(".imgBox").toggle();
      $(this).parents(".storyBox").siblings().find(".imgBox").hide();
      $(this)
        .parents(".storyBox")
        .siblings()
        .find(".headline06")
        .removeClass("on");
      $("html,body").animate({ scrollTop: that.offset().top - faqH }, 300);
      return false;
    });
  }

  if ($(".proSwpier").length) {
    $(".proSwpier").each(function () {
      var proLength = $(this).find(".slideUl > li").length;
      var proSwpier = new Swiper(this, {
        autoplay: false,
        slidesPerView: 1,
        loop: proLength === 1 ? false : true,
        navigation: {
          nextEl: ".next",
          prevEl: ".prev",
        },
        pagination: {
          el: ".swiper-dots",
          type: "bullets",
          clickable: false,
        },
      });
    });
  }


  if ($(".proSmlList").length || $(".proBigList").length) {
    var proSmlLength = $(".proSmlList .smlList > li").length;
    var proBigLength = $(".proBigList .imgList > li").length;

    var proSmlList = new Swiper(".proSmlList", {
      loop: proSmlLength < 6 ? false : true,
      autoplay: false,
      spaceBetween: "7%",
      slideToClickedSlide: true,
      slidesPerView: proSmlLength < 5 ? proSmlLength : 5,
      breakpoints: {
        600: {
          //>=600
          slidesPerView: "auto",
        },
        1024: {
          //>=1024
          direction: "vertical",
          slidesPerView: 5,
        },
      },
    });

    if (window.innerWidth >= 1024) {
      var proBigList = new Swiper(".proBigList", {
        autoplay: false,
        effect: "fade",
        loop: proBigLength === 1 ? false : true,
        spaceBetween: 0,
        thumbs: {
          swiper: proSmlList,
        },
        navigation: { // ナビゲーションボタンの設定を追加
          nextEl: ".proBigList .swiper-button-next",
          prevEl: ".proBigList .swiper-button-prev",
        },
        pagination: {
          el: ".swiper-dots",
          type: "bullets",
          clickable: true,
        },
      });
    } else {
      var proBigList = new Swiper(".proBigList", {
        autoplay: false,
        loop: proBigLength === 1 ? false : true,
        spaceBetween: 0,
        thumbs: {
          swiper: proSmlList,
        },
        navigation: { // ナビゲーションボタンの設定を追加
          nextEl: ".proBigList .swiper-button-next",
          prevEl: ".proBigList .swiper-button-prev",
        },
        pagination: {
          el: ".swiper-dots",
          type: "bullets",
          clickable: true,
        },
      });
    }

    proSmlList.params.slideToClickedSlide = true;
  }

  if ($(".proBigList").length && window.innerWidth > 1024) {
    $(".proBigList li").each(function () {
      var src = $(this).data("src");
      var num = $(this).data("magnify");
      $(this).zoom({
        url: src,
        magnify: num,
      });
    });
  }

  var href = window.location.href;
  $(".gNavi .innerUl li").each(function () {
    var page = $(this).attr("data-page");
    if (href.indexOf(page) > -1) {
      $(this).addClass("on");
    }
  });

  if ($(".artSwiper01").length) {
    var artLength01 = $(".artSwiper01 .slideList > li").length;
    new Swiper(".artSwiper01", {
      loop: false,
      slidesPerView: 1.35,
      spaceBetween: "15.9%",
      freeMode: {
        enabled: true,
        momentumBounce: false,
      },
      resistance: true,
      resistanceRatio: 0,
      navigation: {
        nextEl: ".art-next01",
        prevEl: ".art-prev01",
      },
      breakpoints: {
        600: {
          spaceBetween: "7%",
          freeMode: false,
          loop: artLength01 < 4 ? false : true,
          slidesPerView: 3,
          allowTouchMove: false,
        },
        1024: {
          //>=1024
          direction: "vertical",
          slidesPerView: 3,
          spaceBetween: 36,
          freeMode: false,
          loop: artLength01 < 4 ? false : true,
        },
      },
    });
  }

  if ($(".artSwiper02").length) {
    var artLength02 = $(".artSwiper02 .slideList > li").length;
    new Swiper(".artSwiper02", {
      loop: false,
      slidesPerView: 1.35,
      spaceBetween: "15.9%",
      freeMode: {
        enabled: true,
        momentumBounce: false,
      },
      resistance: true,
      resistanceRatio: 0,
      navigation: {
        nextEl: ".art-next02",
        prevEl: ".art-prev02",
      },
      breakpoints: {
        600: {
          spaceBetween: "7%",
          freeMode: false,
          loop: artLength02 < 4 ? false : true,
          slidesPerView: 3,
          allowTouchMove: false,
        },
        1024: {
          //>=1024
          direction: "vertical",
          slidesPerView: 3,
          spaceBetween: 36,
          freeMode: false,
          loop: artLength02 < 4 ? false : true,
        },
      },
    });
  }

  if ($(".smlSwpier").length && window.innerWidth > 599) {
    $(".smlSwpier").each(function () {
      var smlLength = $(this).find("li").length;
      var smlswiper = new Swiper(this, {
        autoplay: false,
        slidesPerView: 1,
        loop: smlLength === 1 ? false : true,
        navigation: {
          nextEl: ".next",
          prevEl: ".prev",
        },
        pagination: {
          el: ".swiper-dots",
          type: "bullets",
          clickable: false,
        },
      });
    });
  }

  $(window)
    .on("resize", function () {
      $(".swiper-dots").each(function () {
        var width = $(this).innerWidth();
        var num = $(this).find("span").length;
        $(this).addClass("swiper-dots-num" + num);
        $(this)
          .find("span")
          .css("width", width / num);
      });
    })
    .trigger("resize");

  var href = window.location.href;
  $(".gNavi .innerUl li").each(function () {
    var page = $(this).attr("data-page");
    if (href.indexOf(page) > -1) {
      $(this).addClass("on");
    }
  });

  if (href.indexOf("blog") > -1) {
    $(".gHeader .gNavi .innerUl li:last-child").addClass("on");
    $(".gHeader02 .gNavi .innerUl li:last-child").addClass("on");
  }

  if (
    window.innerWidth > 599 &&
    $(".productDetail .product_story .imgBox").length
  ) {
    $(
      ".productDetail .product_story .imgBox .textBox .headline06"
    ).insertBefore($(".productDetail .product_story .imgBox .textBox p:first"));
  } else {
    $(".productDetail .product_story .imgBox .photoBox").insertAfter(
      $(".productDetail .product_story .imgBox .textBox .headline06")
    );
  }

  // var scrollPosition = 0;

  $(".detailsTxt").click(function (event) {
    event.preventDefault();
    event.stopPropagation();

    // scrollPosition = $(window).scrollTop();

    // var $target = $(".ingredientsBox .inner dl.hide");
    // if ($target.css("display") == "none") {
    //   $target.css("display", "block");
    //   $(this).text("詳細を閉じる");
    // } else {
    //   $target.css("display", "none");
    //   $(this).text("詳細を見る");

    //   $(window).scrollTop(scrollPosition);
    // }

    $(".productDetail .rBox .ingredientsBox .inner dl.hide")
      .stop()
      .fadeToggle();
    $(".ingredientsBox").toggleClass("on");
    var element = document.querySelector(".ingredientsBox");
    if ($(".ingredientsBox").hasClass("on")) {
      $(this).text("詳細を閉じる");
      console.log(elementHeight);
    } else {
      $(this).text("詳細を見る");
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
    $(this).prev(".productDetail.rBox .ingredientsBox dl.hide").fadeToggle();
  });

  if (window.innerWidth > 599) {
    $(".selectBox p:visible").click(function () {
      $(this).toggleClass("on");
      $(this).next().find(".select").stop().slideToggle();
    });
  } else {
    $(".selectBox > p").click(function () {
      $(this).toggleClass("on");
      $(this).next().stop().slideToggle();
      $(".selectBg").stop().fadeToggle();
    });

    $(".selectBg,.selectBox .inner .ttl").click(function () {
      $(".selectBox > p").removeClass("on");
      $(".selectBox .inner").slideUp();
      $(".selectBg").fadeOut();
    });
  }
  if ($("#container.pro").length) {
    $(".gradient").addClass("nofix");
  }

  $(".custom-select").each(function () {
    var classes = $(this).attr("class"),
      id = $(this).attr("id"),
      name = $(this).attr("name");
    var template = '<div class="' + classes + '">';
    template +=
      '<span class="custom-select-trigger">' +
      $(this).attr("placeholder") +
      "</span>";
    template += '<div class="custom-options">';
    $(this)
      .find("option")
      .each(function () {
        template +=
          '<span class="custom-option ' +
          $(this).attr("class") +
          '" data-value="' +
          $(this).attr("value") +
          '">' +
          $(this).html() +
          "</span>";
      });
    template += "</div></div>";

    $(this).wrap('<div class="custom-select-wrapper"></div>');
    $(this).hide();
    $(this).after(template);
  });
  $(".custom-option:first-of-type").hover(
    function () {
      $(this).parents(".custom-options").addClass("option-hover");
    },
    function () {
      $(this).parents(".custom-options").removeClass("option-hover");
    }
  );
  $(".custom-select-trigger").on("click", function () {
    $("html").one("click", function () {
      $(".custom-select").removeClass("opened");
    });
    $(this).parents(".custom-select").toggleClass("opened");
    event.stopPropagation();
  });
  $(".custom-option").on("click", function () {
    var ind = $(this).index();
    $(".custom-select-wrapper #SortBy option").removeAttr("selected");
    $(".custom-select-wrapper #SortBy option")
      .eq(ind)
      .attr("selected", "selected");
    $(this)
      .parents(".custom-select-wrapper")
      .find("select")
      .val($(this).data("value"));
    $(this)
      .parents(".custom-options")
      .find(".custom-option")
      .removeClass("selection");
    $(this).addClass("selection");
    $(this).parents(".custom-select").removeClass("opened");
    $(this)
      .parents(".custom-select")
      .find(".custom-select-trigger")
      .text($(this).text());
  });

  $(".custom-select-trigger").text(
    $(".custom-options .custom-option").eq(0).text()
  );
  $(".custom-options .custom-option").eq(0).addClass("selection");
});

$(window).on("load", function () {
  if ($(".proSmlList").length) {
    $(".productDetail .flexBox .proSmlList").addClass("show");
  }

  if (
    $(".proBigList").length &&
    $(".proSmlList").length &&
    window.innerWidth >= 1024
  ) {
    $(window)
      .on("resize", function () {
        var listH = $(".proBigList").innerHeight();
        $(".proSmlList ul").height(listH);
        $(".proSmlList").height(listH);
        setTimeout(function () {
          var listW = $(
            ".productDetail .flexBox .proSmlList .first"
          ).innerHeight();
          console.log(listW);
          $(".productDetail .flexBox .proSmlList").innerWidth(listW);
        }, 150);
      })
      .trigger("resize");
  }
});
